import React from 'react';
import {useQuery} from "react-query";
import ngage from "services/ngage";
import Spinner from "components/Spinner";
import Empty from "components/Empty";
import {ChevronRightIcon, QuestionMarkCircleIcon} from "@heroicons/react/outline";

type Props = {
    exhibitId?: number
}

function ExhibitQuizzes({exhibitId}: Props) {
    let quizParams = {quizzableType: 'exhibit' as const, quizzableId: exhibitId || 0, page: 1}

    const {data: quizzes, isLoading: quizzesLoading} = useQuery(
        ['exhibit.quizzes', quizParams],
        () => ngage.quizzes.all(quizParams),
        {enabled: !!exhibitId}
    )

    if(quizzesLoading){
        return (
            <div className="my-8 flex items-center justify-center">
                <Spinner color={Spinner.colors.DARK}/>
            </div>
        )
    }

    if(!quizzesLoading && !(quizzes?.data.length)){
        return (
            <div className="bg-white mt-2 py-8">
                <Empty
                    icon={QuestionMarkCircleIcon}
                    text="No quizzes available"
                    hint="If a quiz is created for this exhibit it will appear here."
                />
            </div>
        )
    }

    return (
        <ul className="mb-2">
            {quizzes?.data.map(quiz => (
                <li key={quiz.id}>
                    <article className="mt-1 bg-white px-8 py-6 flex justify-between items-center">
                        <div className="flex items-center">
                            <QuestionMarkCircleIcon className="text-brand h-9 w-9"/>
                            <div className="ml-4">
                                <h2 className="font-medium text-base">{quiz.title}</h2>
                                <p className="font-medium text-gray-400 text-sm mt-1">{quiz.description}</p>
                            </div>
                        </div>

                        <ChevronRightIcon className="text-brand h-7 w-7"/>
                    </article>
                </li>
            ))}
        </ul>
    )
}

export default ExhibitQuizzes;